import {
  CalendarIcon,
  CalendarPlus2Icon,
  CalendarRangeIcon,
} from 'lucide-react';

import { cn } from '@/lib/utils';

import type { DateBoxView } from '../date-box';
import { ViewSelectorButton } from './view-selector-button';

export function ViewSelector({
  setView,
  className,
}: {
  setView: React.Dispatch<React.SetStateAction<DateBoxView>>;
  className?: string;
}) {
  return (
    <div className={cn('@container flex w-full flex-row', className)}>
      <ViewSelectorButton
        onClick={() => {
          setView('day');
        }}
      >
        <span className="hidden @sm:inline-block">Day</span>
        <CalendarPlus2Icon />
      </ViewSelectorButton>
      <ViewSelectorButton
        onClick={() => {
          setView('week');
        }}
      >
        <span className="hidden @sm:inline-block">Week</span>
        <CalendarRangeIcon />
      </ViewSelectorButton>
      <ViewSelectorButton
        onClick={() => {
          setView('month');
        }}
      >
        <span className="hidden @sm:inline-block">Month</span>
        <CalendarIcon />
      </ViewSelectorButton>
    </div>
  );
}
